// @flow
export type EmailTaken = {
  type: 'EMAIL_AVAILABILITY',
  payload: { isTaken: boolean },
};

export default function setEmailTaken(isTaken: boolean): EmailTaken {
  return {
    type: 'EMAIL_AVAILABILITY',
    payload: { isTaken },
  };
}
